export default __webpack_public_path__ + "static/media/newNextIcon.59425d06.svg";